import * as React from 'react'
import { cn } from '../../lib/utils'

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      'text-gray-600 font-medium text-base leading-[1.125rem] align-middle font-inter',
      className
    )}
    {...props}
  />
))
Label.displayName = 'Label'

export { Label }